import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllProfessionals = (page, size) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.professionalProfiles,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      page,
      size,
    },
  });
};

export const fetchProfessionalDetails = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.professionalProfile(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteProfessionalProfile = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.professionalProfile(id),
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addProfProfile = (data, id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url:
      id !== null
        ? config.routes.professionalProfile(id)
        : config.routes.professionalProfileCreate,
    method: id !== null ? "put" : "post",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
    data: data,
  });
};
